// removed by extract-text-webpack-plugin
module.exports = {"pageWrapper":"NTrTvcK13A2SXiqBfzu6I","title":"jVmkGYrBH_MB90TFCSjYN","subtitle":"_3-231uoUc9wwxRh79vPEb9","contentWrapper":"_2X-eGWFTSeYN19ClGMIbjg","cardWrapper":"_2Edc8UHM1RENDcS8N4_-O3","controlUnitWrapper":"AUBmQtZtqLvo9gSfSfFvz","staffTabs":"_2m8L6XVjkzvk6RTPK1nNew","modal":"_34DSV-u19s13CTHGV7Jy8o","failModalContentWrapper":"_3l2htaX9iCjBhI8XUlzWzU","failModalTitle":"X_upSKkSr_4KLm9BFbw37","failModalSubTitle":"HSHIjWQbJfSAaLp0pAFyg","failModalButton":"aPqpzf9cK24KSBt8gAMkc"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/MyStaffContainer.scss
// module id = 1846
// module chunks = 0